export enum ChargePickupState {
    active = 0,
    inactive = 1
}

export default class ChargePickup extends Phaser.Physics.Arcade.Sprite {
    shadow: Phaser.GameObjects.Sprite;
    pickupState: ChargePickupState;
    chargeValue: number;

    constructor(scene: Phaser.Scene, x: number,y: number){
        super(scene,x,y,"ChargePickup");

        this.chargeValue = 50;

        const shadow = scene.add.sprite(x,y,"playerShadow");
        scene.add.existing(this);
        scene.physics.add.existing(this);
        
        this.body.setMass(0.1);
        this.body.setCircle(3);
        this.body.setOffset(1,1);
        this.scene.anims.create({
            'key': 'chargePickup',
            'frameRate': 6,
            'frames': this.scene.anims.generateFrameNumbers('chargePickupSpriteSheet', { frames: [0,1,0,1,1,0,1,0] }),
            'repeat': -1,
            'delay': 5000,
            'repeatDelay': 7000
        });

        this.setScale(2.5);
        this.setOrigin(0.5);

        this.anims.play("chargePickup");
        this.shadow = shadow;
        scene.add.existing(this.shadow);
        this.shadow.setScale(2.5);
        this.shadow.setOrigin(0.55,0.25);
        this.shadow.setAlpha(0.75);
        this.setDepth(2);
        this.setPickupState(ChargePickupState.active);

    }

    preUpdate(time: number, delta: number){
        this.shadow.setPosition(this.x, this.y);
        this.anims.update(time,delta);
    }

    setPickupState(newState: ChargePickupState){
        switch(newState){
            case ChargePickupState.active:
                this.setAlpha(1);
                this.anims.setDelay(5000 + (Math.random() * 2000));
                this.anims.setRepeatDelay(7000 + (Math.random() * 7000));
            break;
            case ChargePickupState.inactive:
                this.setAlpha(0.2);
                this.scene.time.delayedCall(30000, ()=> this.setPickupState(ChargePickupState.active));
            break;
        }
        this.pickupState = newState;
    }

    destroy(){
        this.shadow.destroy(true);
        super.destroy();
    }

}